/**
 * ReciboPreviaTermica.jsx
 * Replica exacta del recibo térmico impreso.
 */
import React from "react";

var wrapper = {
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 4,
    maxWidth: 320,
    margin: "12px auto",
    padding: "16px 10px",
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: 13,
    lineHeight: 1.6,
    color: "#111",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
};
var center = { textAlign: "center", margin: 0, padding: 0 };
var bold = { fontWeight: "bold" };
var flexRow = { display: "flex", justifyContent: "space-between", margin: 0, padding: 0 };
var dotLine = { margin: "4px 0", borderTop: "1px dotted #555", };

function fmt(value) {
    var num = Number(value) || 0;
    return "Q " + num.toFixed(2);
}

function fmtFecha(iso) {
    if (!iso) return "";
    try {
        var d = new Date(iso);
        var dd = String(d.getDate()).padStart(2, "0");
        var mm = String(d.getMonth() + 1).padStart(2, "0");
        var yyyy = d.getFullYear();
        var hh = String(d.getHours()).padStart(2, "0");
        var mi = String(d.getMinutes()).padStart(2, "0");
        return dd + "/" + mm + "/" + yyyy + " " + hh + ":" + mi;
    } catch (_) {
        return String(iso);
    }
}

function ReciboPreviaTermica(props) {
    var movimiento = props.movimiento;
    var sucursal = props.sucursal || (movimiento && movimiento.sucursal);
    var utiliza_fel = props.utiliza_fel;
    var conf_tipo_negocio = props.conf_tipo_negocio;

    if (!movimiento || !sucursal) return null;

    var datosEmpresa = sucursal.datos_empresa || {};
    var cliente = movimiento.cliente_proveedor || movimiento.cliente || {};
    var detalles = movimiento.detalles || movimiento.detalle_movimiento || [];
    var usuario = movimiento.usuario || {};
    var nombreUsuario = usuario.first_name || "";
    var datosFel = movimiento.datos_fel;

    return (
        <div style={wrapper}>
            {/* ─── ENCABEZADO ─── */}
            <p style={Object.assign({}, center)}>
                {datosEmpresa.nombre_comercial || datosEmpresa.nombre || sucursal.nombre || ""}
            </p>
            <p style={center}>{sucursal.nombre}</p>
            {sucursal.direccion && (
                <p style={Object.assign({}, center, { fontSize: 11 })}>{sucursal.direccion}</p>
            )}
            {sucursal.telefono && (
                <p style={center}>Tel. {sucursal.telefono}</p>
            )}

            <div style={dotLine} />


            {/* ─── CÓDIGO Y FECHA ─── */}
            <div style={flexRow}>
                <span >Codigo:</span>
                <span>{movimiento.codigo_venta || movimiento.codigo || movimiento.id || ""}</span>
            </div>
            <div style={flexRow}>
                <span >Fecha:</span>
                <span>{fmtFecha(movimiento.creado || movimiento.fecha)}</span>
            </div>
            
            <div style={dotLine} />

            {/* ─── DATOS CLIENTE ─── */}
            <div style={flexRow}>
                <span >Nombre:</span>
                <span>{cliente.nombre || "CONSUMIDOR FINAL"}</span>
            </div>
            <div style={flexRow}>
                <span >NIT:</span>
                <span>{cliente.nit || "CF"}</span>
            </div>
            {cliente.direccion && (
                <div style={flexRow}>
                    <span >Direccion:</span>
                    <span>{cliente.direccion}</span>
                </div>
            )}
            {nombreUsuario && (
                <div style={flexRow}>
                    <span >Usuario:</span>
                    <span>{nombreUsuario}</span>
                </div>
            )}

            <div style={dotLine} />


            {/* ─── ENCABEZADO ARTICULOS ─── */}
            <div style={Object.assign({}, flexRow)}>
                <span>ARTICULOS</span>
                <span>SUB TOTAL</span>
            </div>

            {/* ─── DETALLE PRODUCTOS ─── */}
            {detalles.map(function (d, i) {
                var cant = d.cantidad || 1;
                var precioOriginal = d.precio_original || d.precio || 0;
                var subtotal = d.sub_total || d.subtotal || (cant * precioOriginal);

                // Nombre: campo "producto" es string directo
                var nombre = (typeof d.producto === "string") ? d.producto : (d.producto && d.producto.nombre) || d.producto_nombre || d.nombre || "";

                // Fracción (Par, Unidad, etc.)
                var fraccionNombre = (d.fraccion && d.fraccion.nombre) ? d.fraccion.nombre : "";

                // Código de barras
                var codigoBarras = "";
                if (d.fraccion && d.fraccion.codigos_barras && d.fraccion.codigos_barras.length > 0) {
                    codigoBarras = d.fraccion.codigos_barras[0];
                    if (typeof codigoBarras === "object") codigoBarras = codigoBarras.codigo || "";
                }
                if (d.fraccion && d.fraccion.descripcion_codigo_barras) {
                    codigoBarras = d.fraccion.descripcion_codigo_barras;
                }

                // Línea de descripción: "codigo / nombre / fraccion" o "nombre / fraccion"
                var descLinea = "";
                if (codigoBarras) descLinea += codigoBarras + " / ";
                descLinea += nombre;
                if (fraccionNombre) descLinea += " / " + fraccionNombre;

                // Descuento por item
                var tieneDescuento = d.precio_original && d.desc_porcentaje > 0;

                return (
                    <div key={i} style={{ marginBottom: 6 }}>
                        <p style={{ margin: 0, wordBreak: "break-word", fontSize: 12 }}>{descLinea}</p>
                        <div style={flexRow}>
                            <span>{fmt(precioOriginal)} X {cant}</span>
                            <span>{fmt(tieneDescuento ? (cant * precioOriginal) : subtotal)}</span>
                        </div>
                        {tieneDescuento && (
                            <div>
                                <p style={{ margin: 0, paddingLeft: 10, fontSize: 11 }}>
                                    Descuento ({d.desc_porcentaje}%)
                                </p>
                                <div style={Object.assign({}, flexRow, { paddingLeft: 10, fontSize: 11 })}>
                                    <span>- {fmt(d.desc_monto)} X {cant}</span>
                                    <span>- {fmt(cant * d.desc_monto)}</span>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}

            {/* Crédito por devolución */}
            {Number(movimiento.monto_credito_devolucion) > 0 && (
                <div style={Object.assign({}, flexRow)}>
                    <span>Credito por devolucion</span>
                    <span>-{fmt(movimiento.monto_credito_devolucion)}</span>
                </div>
            )}

            <div style={dotLine} />


            {/* ─── TOTALES ─── */}
            <div style={Object.assign({}, flexRow,  { fontSize: 16 })}>
                <span>TOTAL</span>
                <span>{fmt(movimiento.total || 0)}</span>
            </div>
            <div style={Object.assign({}, flexRow)}>
                <span>PAGO RECIBIDO</span>
                <span>{fmt(movimiento.pago_recibido || movimiento.total || 0)}</span>
            </div>

            {/* Vuelto */}
            {movimiento.vuelto_efectivo != null && Number(movimiento.vuelto_efectivo) !== 0 && (
                <div style={Object.assign({}, flexRow)}>
                    <span>VUELTO</span>
                    <span>{fmt(movimiento.vuelto_efectivo)}</span>
                </div>
            )}

            <div style={dotLine} />


            {/* ─── FEL o NO FACTURA ─── */}
            {datosFel ? (
                <div style={{ textAlign: "center" }}>
                    {datosFel.frase_fel && (
                        <p style={Object.assign({}, center,  { fontSize: 11 })}>{datosFel.frase_fel}</p>
                    )}
                    {datosFel.serie && (
                        <div style={flexRow}>
                            <span>Serie:</span>
                            <span>{datosFel.serie}</span>
                        </div>
                    )}
                    {datosFel.numero && (
                        <div style={flexRow}>
                            <span>Numero:</span>
                            <span>{datosFel.numero}</span>
                        </div>
                    )}
                    {datosFel.uuid && (
                        <div>
                            <p style={Object.assign({}, center,  { fontSize: 11, marginTop: 6 })}>AUTORIZACION FEL</p>
                            <p style={Object.assign({}, center, { fontSize: 9, wordBreak: "break-all", color: "#444" })}>
                                {datosFel.uuid}
                            </p>
                        </div>
                    )}
                    {datosFel.fechaCertificacion && (
                        <div>
                            <p style={Object.assign({}, center, { fontSize: 11 })}>FECHA CERTIFICACION</p>
                            <p style={Object.assign({}, center, { fontSize: 11 })}>
                                {fmtFecha(datosFel.fechaCertificacion)}
                            </p>
                        </div>
                    )}
                    {datosFel.datos_generados && (() => {
                        let datos = null;
                        const raw = datosFel.datos_generados;
                        if (typeof raw === "object" && raw !== null) {
                            datos = raw;
                        } else if (typeof raw === "string") {
                            try {
                                const fixed = raw
                                    .replace(/'/g, '"')
                                    .replace(/None/g, 'null')
                                    .replace(/True/g, 'true')
                                    .replace(/False/g, 'false');
                                datos = JSON.parse(fixed);
                            } catch(e) {
                                console.log("No se pudo parsear datos_generados");
                            }
                        }
                        if (datos && datos.nit_certificador) {
                            return (
                                <div>
                                    <p style={Object.assign({}, center, { fontSize: 11 })}>CERTIFICADOR</p>
                                    <p style={Object.assign({}, center, { fontSize: 10 })}>NIT: {datos.nit_certificador}</p>
                                    <p style={Object.assign({}, center, { fontSize: 10 })}>{datos.nombre_certificador || ""}</p>
                                </div>
                            );
                        }
                        return null;
                    })()}
                </div>
            ) : (
                <div>
                    <p style={Object.assign({}, center, { marginTop: 8 })}>ESTE DOCUMENTO</p>
                    <p style={Object.assign({}, center)}>NO ES UNA FACTURA</p>
                </div>
            )}
        </div>
    );
}

export default ReciboPreviaTermica;